export const GITHUB_REPOS_NUM = 5;
